// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import styling from "./scss/main.scss"
Vue.config.productionTip = false

import VueTouch from "vue-touch"
Vue.use(VueTouch)

// create the event hub instance
const eventHub = new Vue();

// add $bus to vue prototype to allow child components to access the bus via this.$bus
if (typeof Vue.$bus === 'undefined') {
    Object.defineProperty(Vue.prototype, "$bus", {
        value: eventHub,
        enumerable: true,
        configurable: true
    })
}

/* eslint-disable no-new */
new Vue({
    el: '#app',
    template: '<App/>',
    components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js